<template>
    <div :class="detailVisible ? 'list-contanier' : 'list-contanier list-contanier-normal'">
        <div :class="detailVisible ? 'list-contanier-mask' : ''"></div>
        <div class="loading-box" v-if="showLoading">
            <van-loading size="24px" color="#0094ff" type="spinner" text-color="#0094ff" vertical>{{ loadingText
            }}</van-loading>
        </div>
        <div class="my-swipe" :style="!showList || showLoading || detailVisible ? 'visibility: hidden;' : ''">
            <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item>
                    <img src="@/assets/banner5.jpg">
                </van-swipe-item>
                 <van-swipe-item>
                    <img src="@/assets/banner6.jpg">
                </van-swipe-item>
                 <van-swipe-item>
                    <img src="@/assets/banner7.jpg">
                </van-swipe-item>
                 <van-swipe-item>
                    <img src="@/assets/banner8.jpg">
                </van-swipe-item>
                 <van-swipe-item>
                    <img src="@/assets/banner9.jpg">
                </van-swipe-item>
                 <van-swipe-item>
                    <img src="@/assets/banner10.jpg">
                </van-swipe-item>
                 <!-- <van-swipe-item>
                    <img src="@/assets/banner0.jpg">
                </van-swipe-item>
                <van-swipe-item>
                    <img src="@/assets/banner1.jpg">
                </van-swipe-item>
                <van-swipe-item>
                    <img src="@/assets/banner2.jpg">
                </van-swipe-item>
                <van-swipe-item>
                    <img src="@/assets/banner3.jpg">
                </van-swipe-item>
                <van-swipe-item @click="onTapAD">
                    <img src="@/assets/banner4.jpg">
                </van-swipe-item> -->
            </van-swipe>
        </div>
        <div v-show="showList && !showLoading" class="tab-box" :style="detailVisible ? 'visibility: hidden;' : ''">
            <div v-for="(item, index) in tabs" :key="index" @click="changeTab(index)" class="tab">
                <img v-if="activeIndex === index" src="@/assets/tab-active.png">
                <img v-else src="@/assets/tab.png">
                <span>{{ item }}</span>
            </div>
        </div>
        <div v-show="showList && !showLoading" class="list-box" :style="detailVisible ? 'visibility: hidden;' : ''"
            v-if="list.length">
            <div class="list-item" v-for="(item, index) in list" :key="index">
                <div class="list-item-header" @click="item.showChild = !item.showChild">
                    <img v-if="item.category === '专业修复'" src="@/assets/img/pro1/pro.png">
                    <img v-else-if="item.category === '护釉健'" src="@/assets/img/pro2/pro.png">
                    <img v-else-if="item.category === '护敏健龈'" src="@/assets/img/pro3/pro.png">
                    <img v-else-if="item.category === '高端系列'" src="@/assets/img/pro4/pro.png">
                    <img v-else-if="item.category === '基础系列'" src="@/assets/img/pro5/pro.png">
                    <img v-else-if="item.category === '儿童牙膏'" src="@/assets/img/pro6/pro.png">
                    <img v-else-if="item.category === '防蛀抗敏系列'" src="@/assets/img/pro7/pro.png">
                    
                    <div class="header-img-box" v-if="(item.category !== '专业修复' && item.category !== '护釉健') && (item.items && item.items.length > 0)">
                        <img :src="item.items[0].itemImg">
                    </div>

                     <div class="header-img-box" v-if="item.category == '专业修复' && item.items && item.items.length > 0">
                        <img src="@/assets/banner/banner-1.png">
                    </div>

                      <div class="header-img-box" v-if="item.category == '护釉健' && item.items && item.items.length > 0">
                        <img src="@/assets/banner/banner-2.png">
                    </div>

                   
                </div>
                <div v-if="item.items && item.items.length > 0 && item.showChild" class="child-box">
                    <van-row :gutter="15">
                        <van-col :span="12" v-for="one in item.items" :key="one.id" class="mart15">
                            <div class="product-info" @click="clickProduct(one)">
                                <div class="info-pro">{{ one.class_name }}{{ one.series ? one.series.replace('牙膏', '系列')
                                    : '' }}</div>
                                <div class="des-box">
                                    <div class="info-top">
                                        <!-- 
                      <div class="info-pro">{{ one.class_name }}</div>
                      <div class="info-pro">{{ one.series + (one.series && one.series.indexOf('牙膏') == -1 ? '牙膏' : '') }}</div> 
                    -->
                                        <!-- <div class="info-title" v-html="transName(one.name)"></div> -->
                                        <div class="info-title" v-html="one.name"></div>
                                    </div>
                                    <div class="info-bot" v-if="one.highlight">
                                        <div class="info-desc" v-for="(text, index) in returnTexts(one.highlight)"
                                            :key="index">
                                            <!-- <img src="@/assets/img/check.png"> -->
                                            <div class="circle"></div>
                                            <!-- <div class="highlightTxt" v-if="text" v-html="text"></div> -->
                                            <div class="highlightTxt" v-if="text" v-html="returnTxt(text)"></div>
                                            <!-- {{ text || '' }} -->
                                        </div>
                                    </div>
                                </div>
                                <!-- 牙膏图片 -->
                                <div class="prodcut-img-wrap">
                                    <div class="product-img-diy">
                                        <img class="prodcut-img-main" :src="API_URL + one.thumbnail">
                                        <img class="prodcut-img-other" :src="API_URL + one.thumbnail">
                                    </div>
                                </div>
                            </div>
                        </van-col>
                    </van-row>
                    <div class="fold-up" @click="item.showChild = false">
                        <span>收起</span>
                        <img src="@/assets/up.png">
                    </div>
                </div>
                <!-- <div :class="['list-item-body','list-item-body'+index]" v-if="item.items&&item.items.length">
          <div class="list-item-product" v-for="(ite,idx) in item.items" :key="idx" @click="clickProduct(item,ite)">
            <div class="list-item-product-img">
              <img :src="ite.itemImg" alt="">
            </div>
            <div :class="['list-item-product-name',(ite.name&&ite.name.length>6)?'list-item-product-name-small':'']">{{ite.name}}</div>
          </div>
        </div> -->
                <!-- <div class="list-item-footer" v-show="item.items&&item.items.length&&index!=list.length-1">
          <img src="@/assets/img/pro1/proFooter.png" alt="">-
        </div> -->
            </div>
        </div>
        <!-- <div class="temp-wrap">
      <van-button type="primary" size="mini" @click="toInnerPage">内部跳转</van-button>
      <van-button type="primary" size="mini" @click="toOutPage">外部跳转</van-button>
    </div> -->
        <div :style="detailVisible ? 'visibility: hidden;' : ''" class="list-box" v-if="!list.length && !showLoading">
            <div class="no-data">
                {{ noDataMsg || '' }}
            </div>
        </div>
    </div>

    <itemDetail :visible="detailVisible" :detailData="itemObj" @scroll="scrollTo" />
</template>

<script setup>
import { onBeforeMount, onMounted, ref, reactive, toRefs, defineAsyncComponent, watch, nextTick } from 'vue'
import { getProductList, getMaterialType, getProductAllList } from "@/api/service"
import itemDetail from "./itemDetail.vue"
import { eventBus } from "@/utils/eventBus"
import { showFailToast } from 'vant';
import { VanIcon } from 'vant'
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';

const props = defineProps({
    code: {
        type: String,
        default: ''
    },
})

watch(() => props.code, (newValue, oldValue) => {
    // 处理变化
    console.log('处理变化:' + newValue);

})

//const API_URL = import.meta.env.VITE_API_URL
const API_URL = process.env.VUE_APP_BASE_API;
const AD_URL = process.env.VUE_APP_AD_URL;
// const itemDetail = defineAsyncComponent(() => import('./itemDetail.vue'))
// const router = useRouter();
// const route = useRoute()
// const state = {
//     productArrData: [],
//     showLoading: false,
//     noDataMsg: '暂无数据',
//     loadingText: '加载中...',
//     showList: false,
//     detailVisible: false,
//     itemObj: {},
// }

const productArrData = ref([]);
const showLoading = ref(false);
const noDataMsg = ref('暂无数据');
const loadingText = ref('加载中...');
const showList = ref(false);
const detailVisible = ref(false);
const itemObj = ref({});

const activeIndex = ref(0)
const tabs = ref(['修复敏感', '舒缓敏感', '儿童牙膏'])
const list = ref([])
const scrollY = ref(0)
const listContainer = ref(null)

const onTapAD= (item) => {
    console.log(AD_URL)
    window.location.href = AD_URL;
}
const clickProduct = (item) => {
    console.log('点击', item)
    // 隐藏右上角的关闭按钮
    if (window.parent !== window) {
        window.parent.postMessage({ type: 'showCloseBtn', params: [false] })
    }
    scrollY.value = document.body.scrollTop
    // state.itemObj = item
    // state.detailVisible = true
    itemObj.value = item
    detailVisible.value = true
    eventBus.emit('hideCloseBtn', 'end')
    console.log("detailVisible.value:" + detailVisible.value)
}

const scrollTo = () => {
    nextTick(() => {
        // 显示全部产品列表
        //state.showList = true
        showList.value = true
        // 显示右上角的关闭按钮
        if (window.parent !== window) {
            window.parent.postMessage({ type: 'showCloseBtn', params: [true] })
        }
        detailVisible.value = false;
        document.body.scrollTop = scrollY.value
    })
}

const toInnerPage = () => {
    const externalLink = '#小程序://舒适达智能牙敏感检测v2/8DYfUgXnPz3N1Ty';
    // window.location.href = externalLink;
    window.open(externalLink, '_blank');
}

const toOutPage = () => {
    const externalLink = 'https://postpay-2g5hm2oxbbb721a4-1258211818.tcloudbaseapp.com/jump-mp.html';
    // window.location.href = externalLink;
    window.open(externalLink, '_blank');
}

const changeTab = (val) => {
    console.log('changeTab: ' + val)
    activeIndex.value = val
    if (val === 0) {
        list.value = productArrData.value.filter((item) => item.category === '专业修复' || item.category === '护釉健' || item.category === '护敏健龈')
    } else if (val === 1) {
        list.value = productArrData.value.filter((item) => item.category === '防蛀抗敏系列'  || item.category === '高端系列' || item.category === '基础系列' )
        console.log(list.value)
        list.value = [list.value[1], list.value[0], list.value[2]];
    } else {
        list.value = productArrData.value.filter((item) => item.category === '儿童牙膏')
    }
}
const transName = (name) => {
    return name.replace(" ", "<br/>")
}
const returnTexts = (highlight) => {
    //不知道他们用啥符合分割。。。都写上
    let highlightArr = []
    if (highlight.includes(';')) {
        highlightArr = highlight.split(';')
    } else if (highlight.includes('；')) {
        highlightArr = highlight.split('；')
    } else {
        highlightArr = [highlight]
    }
    return highlightArr
}

const returnTxt = (text) => {
    let supStartIndex = text.indexOf('<sup>')
    let supEndIndex = text.indexOf('</sup>')
    let result = ''
    if (supStartIndex > -1) {
        result = toCombine(text, 0, supStartIndex, supEndIndex, result)
    } else {
        result = text
    }
    return result
}

const toCombine = (str, oldEnd, start, end, result) => {
    let newResult = result
    if (start > -1) {
        if (newResult) {
            newResult = newResult + str.substring(oldEnd + 6, start - 1) + '<span style=\'white-space: nowrap;\'>' + str.substring(start - 1, end + 6) + '</span>'
        } else {
            newResult = newResult + str.substring(0, start - 1) + '<span style=\'white-space: nowrap;\'>' + str.substring(start - 1, end + 6) + '</span>'
        }
        let newStart = str.indexOf('<sup>', end + 6)
        let newEnd = str.indexOf('</sup>', end + 6)
        if (newStart > -1) {
            return toCombine(str, end, newStart, newEnd, newResult)
        } else {
            newResult = newResult + str.substring(end + 6)
            return newResult
        }
    }
}

const getListData = () => {
    console.log('code:' + props.code)
    showList.value = false
    // state.productArr = []
    // const host = import.meta.env.VITE_API_URL
    const host = process.env.VUE_APP_BASE_API
    const sortArr = ['专业修复', '护釉健', '护敏健龈', '高端系列', '基础系列', '儿童牙膏']
    showLoading.value = true

    getProductList({}).then((res) => {
        productArrData.value = []
        console.log(res)
        // if (res.status == 200) {

        // } else {
        //     state.showLoading = false
        //     showFailToast('请求异常，请稍后重试')
        // }

        if (res && res.length) {

            // series 分组  并按照上述排序
            const groupedData = {};
            res.forEach((item) => {
                const series = item.series;
                if (!groupedData[series]) {
                    groupedData[series] = [];
                }
                item.itemImg = host + item.highlight_image;
                groupedData[series].push(item);
            });

            const finalData = Object.keys(groupedData).map((category, index) => {
                return {
                    id: index + 1,
                    category: category,
                    items: groupedData[category],
                    showChild: false
                };
            });

            const sortedData = finalData.sort((a, b) => {
                const indexA = sortArr.indexOf(a.category);
                const indexB = sortArr.indexOf(b.category);
                return indexA - indexB;
            });
            const childSort = ['温和薄荷', '草莓口味', '乳牙期特护']
            for (let i = 0; i < sortedData.length; i++) {
                if (sortedData[i].category == "高端系列") {
                    var idx = 1,
                        newArr = []
                    for (let j = 0; j < sortedData[i].items.length; j++) {
                        if (sortedData[i].items[j].name == "多效护理") {
                            newArr[0] = sortedData[i].items[j]
                        } else {
                            newArr[idx++] = sortedData[i].items[j]
                        }
                        if (j == sortedData[i].items.length - 1) {
                            sortedData[i].items = newArr
                        }
                    }
                }
                if (sortedData[i].category == "儿童牙膏") {
                    sortedData[i].items = sortedData[i].items.sort((a, b) => {
                        const indexA = childSort.indexOf(a.name);
                        const indexB = childSort.indexOf(b.name);
                        return indexA - indexB;
                    })
                }
            }
            productArrData.value = sortedData
            list.value = productArrData.value.filter((item) => item.category === '专业修复' || item.category === '护釉健' || item.category === '护敏健龈')
        }
        // if (route.query.tabIndex) {
        //     const index = parseInt(route.query.tabIndex)
        //     changeTab(index)
        // }

        //showList.value = true
        if (props.code) {
            //alert(1)
            queryCurProduct()

        } else {
            showList.value = true
        }
        showLoading.value = false
        console.log(productArrData.value)
    });



}

onBeforeMount(() => {
    getListData()
})
// watch(() => route.query?.tabIndex, (nv) => {
//     // 在这里可以添加路由变化后的处理逻辑
//     changeTab(parseInt(nv))
//     // queryCurProduct()
// });
// watch(() => route.query?.code, (nv) => {
//     // state.itemObj = {}
//     // state.detailVisible = false
//     // 在这里可以添加路由变化后的处理逻辑
//     queryCurProduct()
// });
const queryCurProduct = () => {
    if (props.code) {
        //   interface Data {
        //     keyword: string,
        //     code: any,
        //     skip: number,
        //     limit: number
        //   }
        const pramas = {
            keyword: '',
            skip: 0,
            limit: 10,
            code: props.code,
        };

        getProductAllList(pramas).then((res) => {
            let product;
            let p_list = res;
            p_list.forEach((item) => {
                // if (item.category == res.data.items[0].series) {
                //     item.showChild = true
                // }
                // if (item.category == res[0].series) {
                //     item.showChild = true
                // }
                if(item.code === props.code){
                    product = item
                }
            })
            //clickProduct(res.data.items[0])
            clickProduct(product)
        })
    }
}
onMounted(() => {
    // queryCurProduct()
})
</script>

<style scoped lang="scss">
p {
    margin-block-start: 0px;
    margin-block-end: 0px;
}

.tab-box {
    background-color: #F3F5F9;
    display: flex;
    justify-content: flex-start;
    color: #fff;
    padding-top: 12px;

    .tab {
        width: 33%;
        height: 35px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }

        span {
            position: absolute;
            top: 50%;
            left: 45%;
            transform: translate(-50%, -50%);
            font-size: 14px;
        }
    }
}

.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    height: calc(100vw * 0.56);
    width: 100vw;
    text-align: center;

    img {
        height: calc(100vw * 0.56);
        width: 100vw;
        // height: 200px;
    }
}

.list-contanier {
    z-index: 99999;
    pointer-events: auto;
    overflow-y: auto;
}

.list-contanier-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('../../../assets/mask.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
}

.list-contanier-normal {
    background: url('../../../assets/bg.png');
    flex-direction: column;
}

.list-contanier {
    width: 100%;
    height: 100vh;
    // background: url('@/assets/bg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    position: relative;

    .loading-box {
        width: 100%;
        height: 70vh;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-box {
        background-color: #F3F5F9;
        display: flex;
        flex-direction: column;

        .no-data {
            width: 100%;
            height: 70vh;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ccc;
            font-size: 14px;
        }

        .list-item {
            display: flex;
            flex-direction: column;

            .list-item-header {
                width: 100%;
                height: auto;
                display: flex;
                position: relative;

                img {
                    width: 100%;
                    height: auto;
                }

                .header-img-box {
                    position: absolute;
                    bottom: 15px;
                    left: 30px;
                    z-index: 100;
                    width: 100px;
                    height: auto;
                }
            }

            .list-item-body {
                width: calc(100% - 20px);
                padding: 0 10px;
                height: 100px;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                background: url('../../../assets/img/pro1/proBg.png');
                background-size: 100% 100%;

                .list-item-product {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin-right: 10px;

                    &:last-child {
                        margin-right: 0;
                    }

                    .list-item-product-img {
                        img {
                            width: 75px;
                            height: auto;
                            transform: rotate(-5deg);
                        }
                    }

                    .list-item-product-name {
                        height: 20px;
                        min-width: 50px;
                        padding: 0 5px;
                        margin-top: 5px;
                        // background: linear-gradient(to right, rgba(2,29,165,1), rgba(50,209,255,1));
                        background: url('../../../assets/img/pro1/wordBg.png');
                        background-size: 100% 100%;
                        border-radius: 15px;
                        color: #fff;
                        font-size: 0.6rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .list-item-product-name-small {
                        font-size: 0.6rem;
                    }
                }
            }

            .list-item-body0 {
                background: url('../../../assets/img/pro1/proBg.png');
                background-size: 100% 100%;
            }

            .list-item-body1 {
                background: url('../../../assets/img/pro2/proBg.png');
                background-size: 100% 100%;
            }

            .list-item-body2 {
                background: url('../../../assets/img/pro3/proBg.png');
                background-size: 100% 100%;
            }

            .list-item-body3 {
                background: url('../../../assets/img/pro4/proBg.png');
                background-size: 100% 100%;
            }

            .list-item-body4 {
                background: url('../../../assets/img/pro5/proBg.png');
                background-size: 100% 100%;
            }

            .list-item-body5 {
                background: url('../../../assets/img/pro6/proBg.png');
                background-size: 100% 100%;
            }

            .list-item-footer {
                width: 100%;
                height: 14px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .temp-wrap {
        background: url('../../../assets/img/pro6/proBg.png');
        background-size: 100% 100%;
        display: flex;
        justify-content: space-evenly;
        padding: 10px 0;
    }
}

.child-box {
    padding: 0 15px 15px;
}

.mart15 {
    margin-top: 15px;
}

.product-info {
    border: 1px solid #99C7E3;
    border-radius: 10px;
    background: url('../../../assets/img/detailBg.png') no-repeat center center;
    height: 170px;
    width: 100%;
    background-size: 100% 100%;
    position: relative;

    .info-pro {
        color: rgb(26, 42, 127);
        font-size: 14px;
        font-weight: bolder;
        letter-spacing: 2px;
        text-align: left;
        position: absolute;
        top: 10%;
        // left: 12px;
        left: 10px;
    }

    .des-box {
        display: flex;
        flex-direction: column;
        // width: calc(60%);
        width: calc(64%);
        height: 100%;
        position: absolute;
        // top: 10%;
        top: 19%;
        // left: 12px;
        left: 10px;
        z-index: 2;

        .info-top {
            .info-pro {
                color: rgb(26, 42, 127);
                font-size: 14px;
                font-weight: bolder;
                letter-spacing: 2px;
                text-align: left;
            }

            .info-title {
                color: #0084D3;
                font-size: 13px;
                font-weight: bolder;
                letter-spacing: 2px;
                text-align: left;
                margin-top: 5px;
            }
        }

        .info-bot {
            margin-top: 6px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;

            .info-desc {
                color: #2F3BA7;
                font-size: 2vw;
                text-align: left;
                display: flex;
                // align-content: flex-start;
                margin-top: 3px;
                align-items: flex-start;
                justify-content: flex-start;
                width: 100%;

                img {
                    width: 8px;
                    height: 8px;
                    margin-right: 5px;
                    margin-top: 3px;
                }

                .circle {
                    width: 2px;
                    height: 2px;
                    background: #2F3BA7;
                    border-radius: 50%;
                    margin-right: 3px;
                    margin-top: 5px;
                }

                .highlightTxt {
                    width: calc(100% - 5px);

                    span {
                        white-space: nowrap;
                    }
                }
            }
        }
    }

    .prodcut-img-wrap {
        width: calc(40% - 20px);
        height: 180px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: absolute;
        // top: 11%;
        top: 14%;
        // right: 5px;
        right: 4px;
        z-index: 1;

        .product-img-diy {
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;

            .prodcut-img-main {
                width: 100px;
                height: 32px;
                transform: rotate(90deg);
                margin-top: 50px;
                // position: absolute;
                // top: 14%;
                // left: -30%;
            }

            .prodcut-img-other {
                width: 100px;
                height: 32px;
                transform: rotate(90deg) scaleX(-1);
                // position: absolute;
                // top: 23vh;
                // left: -30%;
                margin-top: 70px;
                object-fit: cover;
                opacity: 0.3;
                mask-image: linear-gradient(to left, white 10%, transparent 20%, transparent 20%);
                -webkit-mask-image: linear-gradient(to left, white 10%, transparent 20%, transparent 100%);
            }
        }
    }
}

.fold-up {
    width: 80px;
    height: 23px;
    line-height: 23px;
    color: #fff;
    background: linear - gradient(to right, #113087, #30C4FB);
    border-radius: 20px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 12px auto 0;

    img {
        width: 13px;
        height: 11px;
        display: inline-block;
        margin-left: 5px;
    }
}
</style>
<style lang="scss">
.info-desc {
    p {
        margin-block-start: 0px;
        margin-block-end: 0px;
    }
}
</style>